
import Vue from 'vue';
import App from './App';
import router from './router';
import './assets/css/style.css';

import VConsole from 'vconsole'

if(location.host.indexOf('test.h5.nongwanjia.net') != -1){
new VConsole();
}


import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import XInput from 'vux/src/components/x-input/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

Vue.config.productionTip = false

Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin, {position: 'middle'})
Vue.component('group', Group)
Vue.component('x-input', XInput)
Vue.component('x-address', XAddress)
Vue.component('x-button', XButton)
Vue.component('x-dialog', XDialog)
Vue.component('x-textarea', XTextarea)
Vue.component('popup', Popup)
Vue.component('popup-picker', PopupPicker)
Vue.component('checker', Checker)
Vue.component('checker-item', CheckerItem)
Vue.component('cell', Cell)
Vue.component('popup-radio', PopupRadio)
Vue.component('check-icon', CheckIcon)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('inline-x-number', InlineXNumber)


new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js